<p-dialog
    [modal]="true"
    [maximizable]="true"
    [header]="'Cadastro de Rotina'"
    [(visible)]="modalVisible"
    (onHide)="fecharModal()"
    styleClass="w-200 max-w-[90%]"
>
    <div class="w-full flex flex-col gap-4 p-4" [formGroup]="form">
        <app-input
            [label]="'Nome'"
            [formControlName]="'Nome'"
        ></app-input>

        <div class="w-full flex sm:flex-row flex-col justify-end gap-4">
            <app-button
                [class]="'w-full md:max-w-45'"
                (click)="fecharModal()"
                variant="danger"
            >Cancelar</app-button>

            <app-button
                [class]="'w-full md:max-w-45'"
                (click)="salvar()"
                variant="success"
            >Salvar</app-button>
        </div>
    </div>
</p-dialog>
